// extracted by mini-css-extract-plugin
export default {"product":"productcomp_product__eCbEX","cross":"productcomp_cross__+EXDD","home":"productcomp_home__A+5xg"};